import { render } from "./InstitutionEbayShippingPrice.vue?vue&type=template&id=5260ca46&scoped=true"
import script from "./InstitutionEbayShippingPrice.vue?vue&type=script&lang=js"
export * from "./InstitutionEbayShippingPrice.vue?vue&type=script&lang=js"

import "./InstitutionEbayShippingPrice.vue?vue&type=style&index=0&id=5260ca46&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5260ca46"]])

export default __exports__